export default __webpack_public_path__ + "scene2_3_bgaee7ff.png";